import moment from 'moment';

import formatCurrency from 'Helper/formatCurrency';
import formatNumber from 'Helper/formatNumber';

const getReportBrandResponse = (response) => {
  const totalData = response?.totalData ?? 0;
  const totalPage = response?.totalPage ?? 0;
  const isDataExist = response?.isDataExist;
  const lastSync = response?.lastSync ? moment(response?.lastSync).format('DD MMMM YYYY, HH:mm:ss') : '-';

  const reports =
    response?.data.map((report) => {
      return {
        brandName: report?.brandName || '-',
        brandId: report?.brandId || '-',
        targetGmv: report?.targetGmv ? formatCurrency(report?.targetGmv) : '-',
        actualGmv: report?.actualGmv ? formatCurrency(report?.actualGmv) : '-',
        achievementGmvPercentage: `${formatNumber(report?.achievementGmvPercentage || 0, 1)}%`,
        targetErr: `${formatNumber(report?.targetErr || 0, 1)}%`,
        actualErr: `${formatNumber(report?.actualErr || 0, 1)}%`,
        achievementErrPercentage: `${formatNumber(report?.achievementErrPercentage || 0, 1)}%`,
        targetCtr: `${formatNumber(report?.targetCtr || 0, 1)}%`,
        actualCtr: `${formatNumber(report?.actualCtr || 0, 1)}%`,
        achievementCtrPercentage: `${formatNumber(report?.achievementCtrPercentage || 0, 1)}%`,
        targetCtor: `${formatNumber(report?.targetCtor || 0, 1)}%`,
        actualCtor: `${formatNumber(report?.actualCtor || 0, 1)}%`,
        achievementCtorPercentage: `${formatNumber(report?.achievementCtorPercentage || 0, 1)}%`,
        targetAov: report?.targetAov ? formatCurrency(report?.targetAov) : '-',
        actualAov: report?.actualAov ? formatCurrency(report?.actualAov) : '-',
        achievementAovPercentage: `${formatNumber(report?.achievementAovPercentage || 0, 1)}%`,
        actualAwd: report?.actualAwd,
        targetViews: report?.targetViews ? formatNumber(report?.targetViews, 1) : '-',
        actualViews: report?.actualViews ? formatNumber(report?.actualViews, 1) : '-',
        achievementViewsPercentage: `${formatNumber(report?.achievementViewsPercentage || 0, 1)}%`,
      };
    }) || [];

  return {
    totalData,
    totalPage,
    isDataExist,
    reports,
    lastSync,
  };
};

export default getReportBrandResponse;
